const AiIcon = ({width = 21, height = 22, fill = "#525252"}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 21 22"
      fill="none"
    >
      <path
        d="M17.4591 6.99953L18.2491 5.24953L19.9991 4.45953C20.3891 4.27953 20.3891 3.72953 19.9991 3.54953L18.2491 2.75953L17.4591 0.999531C17.2791 0.609531 16.7291 0.609531 16.5491 0.999531L15.7591 2.74953L13.9991 3.53953C13.6091 3.71953 13.6091 4.26953 13.9991 4.44953L15.7491 5.23953L16.5391 6.99953C16.7191 7.38953 17.2791 7.38953 17.4591 6.99953ZM9.49906 8.49953L7.90906 4.99953C7.55906 4.21953 6.43906 4.21953 6.08906 4.99953L4.49906 8.49953L0.999062 10.0895C0.219063 10.4495 0.219063 11.5595 0.999062 11.9095L4.49906 13.4995L6.08906 16.9995C6.44906 17.7795 7.55906 17.7795 7.90906 16.9995L9.49906 13.4995L12.9991 11.9095C13.7791 11.5495 13.7791 10.4395 12.9991 10.0895L9.49906 8.49953ZM16.5391 14.9995L15.7491 16.7495L13.9991 17.5395C13.6091 17.7195 13.6091 18.2695 13.9991 18.4495L15.7491 19.2395L16.5391 20.9995C16.7191 21.3895 17.2691 21.3895 17.4491 20.9995L18.2391 19.2495L19.9991 18.4595C20.3891 18.2795 20.3891 17.7295 19.9991 17.5495L18.2491 16.7595L17.4591 14.9995C17.2791 14.6095 16.7191 14.6095 16.5391 14.9995Z"
        fill={fill}
      />
    </svg>
  );
};
export default AiIcon;
